import React, { useState, useContext, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button, Toast, Spinner } from "react-bootstrap";
// import { UserContext } from "../Contexts/lo";
import { useNavigate } from "react-router-dom";
// import api_url from "../Components/url";
// import Refresh from "../Components/refresh";
import { url } from "../Components/url";
import { fetchWithAuth } from "../Components/FetchWithAuth";
function AddUser() {
    const api_url = url;
    // Refresh();
      const roles = ["Counsellor", "Receptionist", "Manager", "Back Office", "Visa Counsellor", "Visa&Application Counsellor", "Lecturer", "Accountant"];
    // const { user } = useContext(UserContext);



    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userRoles, setUserRoles] = useState([]);
    const [userData, setUserData] = useState({ usernames: '', first_name: '', last_name: '', email: '', phone_number: '', password: '', allowed_ip: '', role: [] });


    
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        try {
            const response = await fetchWithAuth(`${api_url}/create_user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "Authorization": `Bearer ${localStorage.getItem('token').slice(1, -1)}`,
                },
                body: JSON.stringify(userData),
                credentials: "include",
            });

            if (response.ok) {
                setSuccessMessage("User updated successfully!");
                setShowToast(true);
                navigate("/users");
            } else {
                const errorData = await response.json();
                setErrorMessage(errorData.error || "Failed to update user.");
                setShowToast(true);
            }
        } catch (error) {
            setErrorMessage("An error occurred. Please try again.");
            setShowToast(true);
        } finally {
            setIsLoading(false);
        }
    };

    const handleRoleChange = (role, checked) => {
        setUserRoles((prevRoles) =>
            checked ? [...prevRoles, role] : prevRoles.filter((r) => r !== role)
        );
        setUserData((prevData) => ({
            ...prevData,
            role: checked ? [...userRoles, role] : userRoles.filter((r) => r !== role),
        }));
    };

    return (
        <Container fluid style={{ backgroundColor: "#FFFFFF", height: "100vh" }}>
            <Row>
                <Col md={12} className="p-4">
                    <Card className="mb-4">
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group controlId="first_name">
                                            <Form.Label>Given Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter First Name"
                                                value={userData.first_name}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, first_name: e.target.value })
                                                }
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="last_name">
                                            <Form.Label>Surname</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Surname"
                                                value={userData.last_name}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, last_name: e.target.value })
                                                }
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={6}>
                                        <Form.Group controlId="email">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                placeholder="Enter Email"
                                                value={userData.email}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, email: e.target.value })
                                                }
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="phone_number">
                                            <Form.Label>Phone Number</Form.Label>
                                            <Form.Control
                                                type="tel"
                                                placeholder="Enter Phone Number"
                                                value={userData.phone_number}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, phone_number: e.target.value })
                                                }
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col md={6}>
                                        <Form.Group controlId="username">
                                            <Form.Label>Username</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Username"
                                                value={userData.username}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, username: e.target.value })
                                                }
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group controlId="username">
                                            <Form.Label>Allowed IP</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Enter Allowed IP"
                                                value={userData.allowed_ip}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, allowed_ip: e.target.value })
                                                }
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Form.Group controlId="password">
                                        <Form.Label>Password</Form.Label>
                                        <Form.Control
                                            type="password"
                                            placeholder="Enter Password"
                                            value={userData.password}
                                            onChange={(e) =>
                                                setUserData({ ...userData, password: e.target.value })
                                            }
                                            required
                                        />
                                    </Form.Group>
                                </Row>
                                <Row className="mt-3">
                                    <Col>
                                        <h4>Roles</h4>
                                        {roles.map((role) => (
                                            <Form.Check
                                                key={role}
                                                id={`role-${role}`}
                                                type="checkbox"
                                                label={role}
                                                value={role}
                                                checked={userRoles.includes(role)}
                                                onChange={(e) => handleRoleChange(role, e.target.checked)}
                                            />
                                        ))}
                                    </Col>
                                    <Col>
                                        <h4>Status</h4>
                                        {["Active", "Inactive"].map((status) => (
                                            <Form.Check
                                                key={status}
                                                id={`status-${status}`}
                                                type="radio"
                                                label={status}
                                                value={status}
                                                checked={userData.status === status}
                                                onChange={(e) =>
                                                    setUserData({ ...userData, status: e.target.value })
                                                }
                                            />
                                        ))}
                                    </Col>
                                </Row>
                                <Row className="mt-3">
                                    <Col>
                                        <Button type="submit" variant="primary" className="w-100" disabled={isLoading}>
                                            {isLoading ? <Spinner animation="border" size="sm" /> : "Save"}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            <Toast
                onClose={() => setShowToast(false)}
                show={showToast}
                delay={3000}
                autohide
                className="position-fixed top-0 end-0 m-3"
            >
                <Toast.Header>
                    <strong className="me-auto">
                        {successMessage ? "Success" : "Error"}
                    </strong>
                </Toast.Header>
                <Toast.Body>{successMessage || errorMessage}</Toast.Body>
            </Toast>
        </Container>
    );
}

export default AddUser;
